import { Card } from "uikit/components";
import styles from "./MunicipalitySchoolsAttendanceView.module.styl";
import { arrayOf, number, shape, string } from "prop-types";
import React from "react";
import MunicipalitySchoolsAttendanceRow from "../MunicipalitySchoolsAttendanceRow/MunicipalitySchoolsAttendanceRow";

export default function MunicipalitySchoolsAttendanceView({ municipalityId, schoolsAttendance }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="municipality-attendance-form">
                <div className={styles.schoolName}>Название организации</div>
                <div className={styles.attendancePercent}>Посещаемость за прошлую неделю</div>
            </div>
            <div>
                {schoolsAttendance?.map((item) => (
                    <MunicipalitySchoolsAttendanceRow
                        key={item.schoolId}
                        schoolAttendance={item}
                        municipalityId={municipalityId}
                    />
                )) ?? []}
            </div>
        </Card>
    );
}

MunicipalitySchoolsAttendanceView.propTypes = {
    municipalityId: number.isRequired,
    schoolsAttendance: arrayOf(
        shape({
            schoolId: number.isRequired,
            schoolName: string.isRequired,
            attendancePercent: number.isRequired,
        }),
    ),
};
